type apiStatus = "pending" | "error" | "idle";
export const enum DepartmentId {
  PRODUCE = "PR",
  MEAT = "MT"
}

export interface ProduceMovementRecordInitialState {
  searchProductListData: {
    searchQuery: string;
    searchProductsLoading: false;
    searchResults: [];
  };
  blockNavigation: boolean;
  deletedItemsIds: string[];
  weekEndingDate: string;
  subClassIds: string[];
  departments: {
    id: string;
    label: string;
    tabIndex: number;
    canSubmit: boolean;
    vendors: string[] | null;
    orderWindow?: any[];
  }[];
  defaultDeliveryDays: number[];
  defaultOrderDays: number[];
  isActive: boolean;
  showFullPageLoading: boolean;
  departmentId: DepartmentId;
  selectedItems: string[];
  actualSales: number | null;
  forecastedSales: number | null;
  defaultForecastedSales: number | null;
  tableData: {
    salesData: {
      [key: number]: DailyData;
    };
    commodities: {
      [key: string]: CommodityInterface;
    };
    previousWeekCommodities: {
      [key: string]: PreviousWeekCommodityData;
    };
    futureWeekData: FutureWeekCommodityData;
    minForcastSales: number | null;
  };
  defaultTableData: {
    salesData: {
      [key: number]: DailyData;
    };
    commodities: {
      [key: string]: CommodityInterface;
    };
    previousWeekCommodities: {
      [key: string]: PreviousWeekCommodityData;
    };
    futureWeekData: FutureWeekCommodityData;
    minForcastSales: number | null;
  };
  discrepancyList: {
    status: apiStatus;
    data: any[];
  };
  tableDataStatus: apiStatus;
  tableDataError: any;
  tableDataErrorCount: number;
  filteredCommodities?: any[];
  lastAccessedDate?: string | null;
}

export interface CommodityInterface {
  itemId: string;
  description: string;
  upc: string;
  isRandomWeight: boolean;
  subclassId: string;
  pack: string;
  size: string;
  masterDisplay: number | null;
  casesPerThousand: number | null;
  dailyProductData: {
    [key: number]: DailyProductData;
  };
  totalCasesSold: number | null;
  soldCasesPer1000: number | null;
  sortOrder: number | null;
}

export interface DailyProductData {
  day: number;
  productRequired: number | null;
  inventoryBackStore: number | null;
  inventoryCounter: number | null;
  order: number | null;
  received: number | null;
  productAvailable: number | null;
  overShort: number | null;
  casesSold: number | null;
}

export interface PreviousWeekCommodityDailyData {
  day: number;
  overShort: number | null;
  productAvailable: number | null;
  casesSold: number | null;
  actualSales: number | null;
}

export interface CommodityDailyData {
  day: number;
  inventoryBackStore: number | null;
  inventoryCounter: number | null;
  received: number | null;
}

export interface DailyData {
  day: number;
  deliveredBy: boolean;
  orderedBy: boolean;
  orderFactor: number | null;
  forecastSales: number | null;
  actualSales: number | null;
  isActualSalesEditable: boolean;
}

export interface FormattedCommodityData {
  itemId: string;
  description: string;
  upc: string;
  isRandomWeight: boolean;
  subclassId: string;
  pack: string;
  size: string;
  masterDisplay: number | null;
  casesPerThousand: number | null;
  dailyData: {
    [key: number]: CommodityDailyData & DailyData;
  };
}

export interface PreviousWeekCommodityData {
  itemId: string;
  casesPerThousand: number | null;
  masterDisplay: number | null;
  dailyProductData: {
    [key: number]: PreviousWeekCommodityDailyData;
  };
  totalCasesSold: number | null;
  soldCasesPer1000: number | null;
  actualSales: number | null;
}

export interface FutureWeekCommodityData {
  totalForecastedSalesTillNextDeliveryDay: number | null;
  salesData: {
    [key: number]: FutureWeekSalesData;
  };
}

export interface FutureWeekSalesData {
  day: number;
  forecastSales: number | null;
}
